<template>
  <div class="view" :filters-opened="filtersOpened">
    <section class="banner">
      <div class="banner-background">
        <img v-if="!isMobile" src="@/assets/cast_map_banner.svg">
      </div>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="232.521" height="164.969" viewBox="0 0 232.521 164.969"><defs><filter id="mbb-a" x="23.895" y="3.739" width="180.402" height="161.23" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="mbb-c" x="155.675" y="0" width="76.846" height="76.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="mbb-e" x="99.233" y="0.902" width="70.532" height="70.532" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><filter id="mbb-g" x="0" y="84.799" width="65.119" height="65.119" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="h"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-370.5 -303.5)"><g transform="matrix(1, 0, 0, 1, 370.5, 303.5)" filter="url(#mbb-a)"><path d="M61.588,19.367c21.787,17.14,35.462,1.125,56.426,35.557s-17.41,70.543-63.682,52.762-64.746-39.8-47.457-72.424S39.8,2.227,61.588,19.367Z" transform="translate(51.91 12.09)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 370.5, 303.5)" filter="url(#mbb-c)"><ellipse cx="9.923" cy="9.923" rx="9.923" ry="9.923" transform="translate(184.17 16.5)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 370.5, 303.5)" filter="url(#mbb-e)"><ellipse cx="6.766" cy="6.766" rx="6.766" ry="6.766" transform="translate(127.73 17.4)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 370.5, 303.5)" filter="url(#mbb-g)"><ellipse cx="4.06" cy="4.06" rx="4.06" ry="4.06" transform="translate(28.5 101.3)" fill="#00a1ed"/></g></g></svg>
          <h1>SmartMap</h1>
        </div>
        <svg v-if="!isMobile" class="map-photo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="482.3" height="313.94" viewBox="0 0 482.3 313.94"><defs><pattern id="mp-a" width="1" height="1" viewBox="75.945 38.233 294.369 191.612"><image preserveAspectRatio="xMidYMid slice" width="482.3" height="321.533" :xlink:href="require('@/assets/shapes/map_photo-image.jpg')"/></pattern></defs><path d="M-2413.209,237.07c-17.646-47.784-34.768-42.949-52.432-38.114-15.1,4.135-30.606,8.269-47.17-20.5-35.936-62.4.62-183.748,170.924-185.058,82.823-.637,113.22,15.918,132.311,32.473,20.165,17.486,27.716,34.972,71.113,32.2,84.48-5.4,133.453,110.071,58.307,190.6-35.9,38.471-106.016,57.766-173.056,57.762C-2326.5,306.436-2396.113,283.366-2413.209,237.07Zm-57.22,17.065a6.27,6.27,0,0,1,6.27-6.27,6.271,6.271,0,0,1,6.27,6.27,6.271,6.271,0,0,1-6.27,6.27A6.27,6.27,0,0,1-2470.429,254.135Zm29.641.57a3.42,3.42,0,0,1,3.42-3.42,3.42,3.42,0,0,1,3.42,3.42,3.42,3.42,0,0,1-3.42,3.42A3.42,3.42,0,0,1-2440.788,254.7Zm-23.941-30.21a14.25,14.25,0,0,1,14.25-14.25,14.25,14.25,0,0,1,14.251,14.25,14.251,14.251,0,0,1-14.251,14.251A14.25,14.25,0,0,1-2464.729,224.494ZM-2182,30.691a15.39,15.39,0,0,1,15.39-15.39,15.39,15.39,0,0,1,15.391,15.39,15.39,15.39,0,0,1-15.391,15.39A15.39,15.39,0,0,1-2182,30.691Zm-6.84-31.351A6.84,6.84,0,0,1-2182-7.5a6.84,6.84,0,0,1,6.84,6.84A6.839,6.839,0,0,1-2182,6.18,6.84,6.84,0,0,1-2188.844-.66Z" transform="translate(2525.361 7.5)" fill="url(#mp-a)"/></svg>
      </div>
    </section>
    <section class="map">
      <div class="wrapper">
        <h2>CAST Directory of European Tourism</h2>
        <p>Find all our partners and networks across Europe.</p>
      </div>
      <div class="search-field">
        <div class="wrapper">
          <input type="search" placeholder="Search company names, locations, tags…" v-model="searchTerms">
          <button v-if="isMobile" class="ic" @click="filtersOpened = !filtersOpened">
            <i v-if="filtersOpened" class="ic ic-close"></i>
            <i v-else class="fas fa-filter"></i>
          </button>
        </div>
      </div>
      <div class="filters">
        <div class="wrapper">
          <div class="selectors">
            <select class="filter" v-model="categoryFilter">
              <option value="">All Organization Types</option>
              <option v-for="type in types" :key="type" :value="type">{{type}}</option>
            </select>
            <select class="filter" v-model="geographicFilter">
              <option value="">All Geographic Remits</option>
              <option v-for="geographic in geographics" :key="geographic" :value="geographic">{{geographic}}</option>
            </select>
            <select class="filter" v-model="countryFilter">
              <option value="">All Countries</option>
              <option v-for="country in countries" :key="country" :value="country">{{country}}</option>
            </select>
          </div>
          <button v-if="selectedCompany || categoryFilter || geographicFilter || countryFilter" class="reset-btn" @click="categoryFilter = geographicFilter = countryFilter = ''; selectedCompany = null">Reset filters <i class="fas fa-times-circle"></i></button>
        </div>
      </div>
      <div class="map-container">
        <GmapMap
          id="map"
          ref="map"
          :zoom="4"
          :center="{ lat: 51.9727551, lng: 6.6605747 }"
          map-type-id="terrain"
          :options="{
            styles: mapConfig,
            mapTypeControl: false,
            streetViewControl: false,
          }"
        >
        </GmapMap>
        <div class="companies-list" @mousewheel="captureScroll">
          <div class="company-item" :style="{borderColor: colors[company.types[0]]}" v-for="company in results" :key="company.id">
            <div class="company-side">
              <div class="company-logo" :style="{
                backgroundImage: `url(${company.image || require('@/assets/cast_logo_only.svg')})`,
                backgroundSize: company.image ? null : '70% auto'
              }"></div>
              <a class="btn" :style="{backgroundColor: colors[company.types[0]] || '#343434'}" :href="company.website" target="_blank">Visit website</a>
            </div>
            <div class="company-info">
              <div class="company-name" :style="{color: colors[company.types[0]]}"><h5>{{company.name}}</h5></div>
              <div class="company-description">{{getDescription(company.description, isMobile ? 160 : 200)}}</div>
              <div class="company-types">{{company.types.join(', ')}}</div>
              <div class="company-country">{{company.country}}</div>
            </div>
          </div>
        </div>
        <div class="support">
          <img src="@/assets/cast_logo_simple.svg" alt="CAST Network">
          <p>Are you a supporting organisation?</p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdxdC9jrnuo8fNRFiQJw9kBGgipbPyuv2HTGUiYOku93O6CTg/viewform" target="_blank" class="btn">Join network</a>
        </div>
      </div>
    </section>
    <Newsletter />
  </div>
</template>

<script>
/* global google */

import {mapGetters} from 'vuex'
import MarkerClusterer from '@google/markerclustererplus'
import Newsletter from '../components/Newsletter'

export default {
  name: 'SmartMap',
  components: {
    Newsletter
  },
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    }),
    results() {
      if(!this.companies) return []
      const search = this.searchTerms.toLowerCase()
      return this.companies.filter(company => {
        if(this.selectedCompany) return company.id === this.selectedCompany.id
        if(search) {
          if(!company.name.toLowerCase().includes(search)) return false
        }
        if(this.categoryFilter && !company.types.includes(this.categoryFilter)) return false
        if(this.geographicFilter && !company.geographic.includes(this.geographicFilter)) return false
        if(this.countryFilter && company.country !== this.countryFilter) return false
        return true
      })
    },
    countries() {
      if(!this.companies) return []
      return this.companies.reduce((countries, company) => {
        if(!countries.includes(company.country)) countries.push(company.country)
        return countries
      }, [])
    }
  },
  data() {
    return {
      companies: null,
      markerClusterer: null,
      selectedCompany: null,
      filtersOpened: false,
      searchTerms: '',
      categoryFilter: '',
      geographicFilter: '',
      countryFilter: '',
      types: [
        'Incubator',
        'Investor Network',
        'Cluster',
        'Chamber of Commerce',
        'Accelerator',
        'Development Centre',
        'Association',
        'Startup',
        'SME',
        'Foundation',
        'BIC',
        'Non-profit'
      ],
      colors: {
        'Incubator': '#0D988C',
        'Investor Network': '#8ABB2A',
        'Cluster': '#880F50',
        'Chamber of Commerce': '#D4177C',
        'Accelerator': '#FFD400',
        'Development Centre': '#F77E0B',
        'Startup': '#FF832B',
        'SME': '#1AC500',
        'Association': '#E77323',
        'Foundation': '#BCBCCB',
        'BIC': '#00A1ED',
        'Non-profit': '#ff6666'
      },
      geographics: [
        'Local',
        'Regional',
        'National',
        'European',
        'International'
      ],
      mapConfig: require('@/assets/map-config.json')
    }
  },
  watch: {
    results(list) {
      this.$refs.map.$mapPromise.then(map => {
        if(!this.markerClusterer) this.markerClusterer = new MarkerClusterer(map/*, [], {
          styles: [
            {
              textColor: '#F77E0B',
              textSize: 25,
              url: require('@/assets/cast_map_cluster.png'),
              width: 111,
              height: 111,
              backgroundPosition: '0, 6'
            }
          ]
        }*/)
        this.markerClusterer.clearMarkers()
        const bounds = new google.maps.LatLngBounds()
        const markers = list.filter(company => company.latitude && company.longitude).map(company => {
          const marker = new google.maps.Marker({
            map: map,
            position: { lat: company.latitude, lng: company.longitude }
          })
          marker.addListener('click', () => {
            this.selectedCompany = company
          })
          bounds.extend(marker.position)
          return marker
        })
        this.markerClusterer.addMarkers(markers)
        map.fitBounds(bounds)
      })
    }
  },
  methods: {
    captureScroll(e) {
      const target = e.currentTarget
      if(this.isMobile) {
        target.scrollLeft += e.deltaY
        e.preventDefault()
        e.stopPropagation()
        e.returnValue = false
        return false
      }
      else if(((target.scrollTop === 0) && e.deltaY < 0) || ((target.scrollTop + target.clientHeight === target.scrollHeight) && e.deltaY > 0)) {
        e.preventDefault()
        e.stopPropagation()
        e.returnValue = false
        return false
      }
    },
    getDescription(html, max = 200) {
      const div = document.createElement('div')
      div.innerHTML = html
      const text = div.innerText
      div.remove()
      return text.length > max ? text.slice(0, max) + '...' : text
    }
  },
  mounted: function() {
    this.companiesRef = this.db().collection('network').where('status', '==', 'accepted').onSnapshot(companies => {
      this.companies = companies.docs.map(company => company.data())
      this.preloadImages([
        require('@/assets/shapes/map_photo-image.jpg')
      ])
      .then(() => {
        this.$store.commit('setPageLoading', false)
      })
      .catch(() => {
        this.$store.commit('setPageLoading', false)
      })
    })
  },
  beforeDestroy: function() {
    if(this.companiesRef) this.companiesRef()
  }
}
</script>

<style scoped>
.view {
  /* background: url(../assets/cast_map_banner.jpg) no-repeat center top/1920px auto; */
}

.banner {
  position: relative;
  padding-top: 235px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .wrapper {
  padding-left: 200px;
}

.banner h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  color: #fff;
}

.map-photo {
  position: absolute;
  top: -64px;
  left: 506px;
  width: 482px;
}

.map {
  margin-top: 148px;
  margin-bottom: 206px;
}

.page-title {
  position: relative;
}

.page-title > svg {
  position: absolute;
  left: 0;
  top: -58px;
}

.map h2 {
  font-size: 1.71em;
  text-transform: uppercase;
  color: #00A1ED;
}

.map-container {
  position: relative;
}

.search-field {
  margin-top: 8px;
  z-index: 2;
}

.filters {
  z-index: 1;
}

.search-field,
.filters {
  box-shadow: 0 6px 12px rgba(0,0,0,.05);
  position: relative;
}

.search-field input {
  height: 62px;
  border: none;
  background: url(../assets/cast_ic_search.svg) no-repeat left center/18px 18px;
  padding-left: 34px;
}

.search-field input::placeholder {
  color: #BCBCCB;
}

.filters .wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
}

.filters .selectors {
  display: flex;
}

.filters .filter {
  width: 220px;
  height: 32px;
  margin-right: 20px;
  border-color: #00A1ED;
  color: #00A1ED;
  border-radius: 4px;
  background-image: url(../assets/cast_ic_arrow-down-b.svg);
}

.filters .reset-btn {
  height: 32px;
  color: #00A1ED;
  border: 1px solid #00A1ED;
  border-radius: 4px;
  padding: 0 12px;
}

.filters .reset-btn i {
  font-size: 11px;
  margin-left: 2px;
}

.support {
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 256px;
  height: 256px;
  background: #fff;
  left: 275px;
  bottom: -128px;
  border-radius: 50%;
  text-align: center;
  box-shadow: 0 14px 28px rgba(0,0,0,.05);
}

.support img {
  display: block;
  width: 88px;
}

.support p {
  margin-top: 12px;
  font-size: 12px;
}

.support .btn {
  margin-top: 12px;
  flex-grow: 0;
  min-width: 0;
  width: 120px;
  height: 36px;
  padding: 0;
  font-size: .79em;
}

.companies-list {
  position: absolute;
  top: 24px;
  bottom: 24px;
  right: 64px;
  width: 406px;
  overflow: auto;
  padding-right: 8px;
  /* overscroll-behavior: none; */
}

.companies-list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.companies-list::-webkit-scrollbar-track {
  background: rgba(82, 82, 102, 0);
  border-radius: 3px;
}

.companies-list::-webkit-scrollbar-thumb {
  background: rgba(82, 82, 102, .3);
  border-radius: 3px;
}

.company-item {
  display: flex;
  width: 100%;
  background: #fff;
  padding: 32px 20px;
  border-left: 6px solid;
  margin-bottom: 24px;
  border-radius: 4px;
}

.company-item:last-child {
  margin-bottom: 0;
}

.company-item .company-info {
  margin-left: 16px;
  line-height: 1.3;
  color: #BCBCCB;
}

.company-item .company-logo {
  width: 128px;
  height: 128px;
  flex-shrink: 0;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(../assets/cast_logo_simple.svg);
  margin: 0 auto 26px;
}

.company-item .btn {
  width: 128px;
  height: 38px;
  font-size: .86em;
  min-width: 0;
  padding: 0;
}

.company-item .company-name:after {
  content: '';
  display: block;
  width: 83px;
  height: 1px;
  background-color: currentColor;
  margin: 12px 0;
}

.company-item .company-name h5 {
  font-weight: 500;
  font-size: 1.43em;
  line-height: 1;
  color: #707070;
}

.company-item .company-website {
  font-weight: bold;
  margin: 8px 0;
}

.company-item .company-description {
  margin-bottom: 32px;
}

.company-item .company-types {
  margin-bottom: 4px;
}

#map {
  height: 740px;
  border-bottom: 2px solid #fff;
  box-shadow: 0 6px 12px rgba(0,0,0,.05);
}

@media screen and (max-width: 1024px) {
  .banner .wrapper {
    padding: 0;
    text-align: center;
  }
  .banner h1 {
    color: #00A1ED;
  }
  .banner h1:after {
    content: '';
    display: block;
    margin: 16px auto 0;
    width: 60px;
    height: 1px;
    background: currentColor;
  }
  .map {
    position: relative;
    margin: 72px 0 48px;
    padding-bottom: 24px;
    overflow: hidden;
  }
  #map {
    height: calc(60vh - 78px);
    border: none;
    margin-bottom: 16px;
  }
  .companies-list {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    top: auto;
    width: auto;
    height: calc(40vh + 14px);
    display: flex;
    padding: 0 16px 14px;
    -webkit-overflow-scrolling: touch;
  }
  .company-item {
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    width: 406px;
    max-width: calc(100vw - 48px);
    margin: 0 16px 0 0;
    padding: 16px 20px;
    border-left: none;
    border-top: 6px solid;
    box-shadow: 0 6px 12px rgba(0,0,0,.05);
  }
  .company-item .company-name {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    min-height: 76px;
    padding-left: 92px;
  }
  .company-item .company-name:after {
    margin-bottom: 0;
  }
  .company-item .company-info {
    margin-left: 0;
  }
  .company-item .company-logo {
    position: absolute;
    width: 76px;
    height: 76px;
  }
  .company-item .company-description {
    margin-bottom: 16px;
  }
  .company-item .btn {
    position: absolute;
    bottom: 16px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .support {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    margin: auto;
    margin-top: 48px;
  }
  .search-field {
    background: #fff;
  }
  .search-field .wrapper {
    display: flex;
    align-items: center;
  }
  .search-field input {
    height: 48px;
    padding-right: 0;
  }
  .search-field button.ic {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    color: #00A1ED;
    border: 1px solid;
    border-radius: 50%;
  }
  .search-field button.ic .ic {
    display: block;
    width: 14px;
    height: 14px;
    margin: auto;
  }
  [filters-opened] .search-field button.ic {
    background-color: #00A1ED;
  }
  .filters {
    position: absolute;
    height: calc(60vh - 78px);
    right: 0;
    background: #fff;
    box-shadow: -14px -16px 28px rgba(0,0,0,.05);
    padding: 0 24px;
    transform: translateX(100%);
    transition: transform .16s ease-out;
  }
  [filters-opened] .filters {
    transform: none;
  }
  .filters .wrapper {
    position: static;
    display: block;
    width: auto;
    max-width: none;
    margin: 0;
  }
  .filters .selectors {
    display: block;
  }
  .filters .filter {
    margin: 16px 0 0;
  }
  .filters .reset-btn {
    position: absolute;
    right: 24px;
    bottom: 24px;
    margin: auto;
  }
}

@media screen and (max-width: 680px) {
  .banner {
    padding-top: 172px;
  }
}
</style>

